// removed by extract-text-webpack-plugin
module.exports = {"root":"Image__root--2yUDP","container":"Image__container--1I_M-","image":"Image__image--1g11_","bounce":"Image__bounce--1k2NJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Image/Image.css
// module id = ./src/components/Library/Image/Image.css
// module chunks = 1